import React from "react";
import VendorPaymentComponent from "./VendorPaymentComponent";
import Uri from "../../Network/Uri";
import {
  ADD_PAYMENT,
  GET_PAYMENTS,
  UPDATE_PAYMENT,
  DELETE_PAYMENT,
  GET_VENDORS,
  GET_VENDOR_INVOICES,
} from "../../Network/ApiPaths";
import postClientDataResponse from "../../Network/PostClientDataResponse";
import getResponseClient from "../../Network/GetClientDataResponse";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

let storeFresh;
let clientHost;

class VendorPaymentContainer extends React.Component {
  constructor(props) {
    super();
    const client = window.localStorage.getItem("clientAccess");
    storeFresh = JSON.parse(client);
    if (storeFresh !== null) {
      clientHost = storeFresh.host;
    }

    this.state = {
      payments: [],
      vendors: [],
      invoices: [],
      // Form Fields
      pendingAmount:"",
      selectedVendor: "",
      selectedInvoice: "",
      paymentAmount: "",
      paymentDate: "",
      balance_after:"",
      paymentMode: "",
      transactionRef: "",
      notes: "",
      paymentFile: null,
      // Filters
      filterVendorId: "",
      filterFromDate: "",
      filterToDate: "",
    };
  }

  componentDidMount() {
    this.getPayments();
    this.getVendors();
    this.getInvoices();
  }

  // ===== Handlers for Form Fields =====
  onVendorChange = (e) => this.setState({ selectedVendor: e.target.value });
  onInvoiceChange = (e) => {
  const selectedInvoice = e.target.value;
  const invoice = this.state.invoices.find((inv) => inv.id === selectedInvoice);

  this.setState({
    selectedInvoice,
    pendingAmount: invoice ? invoice.balance_amount : "",
    balance_after: invoice ? invoice.balance_amount - this.state.paymentAmount : ""
  });
  };
  onPaymentAmountChange = (e) => {
  const paymentAmount = e.target.value;
  const invoice = this.state.invoices.find((inv) => inv.id === this.state.selectedInvoice);

  this.setState({
    paymentAmount,
    balance_after: invoice ? invoice.balance_amount - paymentAmount : ""
  });
};
  onPaymentDateChange = (e) => this.setState({ paymentDate: e.target.value });
  onPaymentModeChange = (e) => this.setState({ paymentMode: e.target.value });
  onTransactionRefChange = (e) => this.setState({ transactionRef: e.target.value });
  onNotesChange = (e) => this.setState({ notes: e.target.value });
  onPaymentFileChange = (e) => this.setState({ paymentFile: e.target.files[0] });

  // ===== Handlers for Filters =====
  onFilterVendorChange = (e) => this.setState({ filterVendorId: e.target.value });
  onFilterFromDateChange = (e) => this.setState({ filterFromDate: e.target.value });
  onFilterToDateChange = (e) => this.setState({ filterToDate: e.target.value });

  onResetFilters = () => {
    this.setState({
      filterVendorId: "",
      filterFromDate: "",
      filterToDate: "",
    });
  };

  // ===== API Calls =====
  addPayment = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("vendor_id", this.state.selectedVendor);
    formData.append("invoice_id", this.state.selectedInvoice);
    formData.append("pending_amount",this.state.pendingAmount);
    formData.append("payment_amount", this.state.paymentAmount);
    formData.append("payment_date", this.state.paymentDate);
    formData.append("balance_after",this.state.balance_after);
    formData.append("payment_mode", this.state.paymentMode);
    formData.append("transaction_ref", this.state.transactionRef);
    formData.append("notes", this.state.notes);
    formData.append("store_id", storeFresh.storeId);

    if (this.state.paymentFile) {
      formData.append("payment_file", this.state.paymentFile);
    }

    postClientDataResponse(
      clientHost + ADD_PAYMENT,
      storeFresh.key,
      formData,
      () => this.getPayments(),
      (err) => console.log(err)
    );
  };

  getPayments = () => {
    var apiPath = new Uri(clientHost + GET_PAYMENTS).addQueryParam("store_id", storeFresh.storeId);
    getResponseClient(
      apiPath,
      storeFresh.key,
      (res) => this.setState({ payments: res.result }),
      (err) => console.log(err)
    );
  };

  getVendors = () => {
    var apiPath = new Uri(clientHost + GET_VENDORS).addQueryParam("store_id", storeFresh.storeId);
    getResponseClient(
      apiPath,
      storeFresh.key,
      (res) => this.setState({ vendors: res.result }),
      (err) => console.log(err)
    );
  };

  getInvoices = () => {
    var apiPath = new Uri(clientHost + GET_VENDOR_INVOICES).addQueryParam("store_id", storeFresh.storeId);
    getResponseClient(
      apiPath,
      storeFresh.key,
      (res) => this.setState({ invoices: res.result }),
      (err) => console.log(err)
    );
  };

  deletePayment = (id) => {
    var apiPath = new Uri(clientHost + DELETE_PAYMENT).addQueryParam("id", id);
    getResponseClient(
      apiPath,
      storeFresh.key,
      () => this.getPayments(),
      (err) => console.log(err)
    );
  };

  updatePayment = (payment) => {
    const formData = new FormData();
    formData.append("id", payment.id);
    formData.append("vendor_id", payment.vendor_id);
    formData.append("invoice_id", payment.invoice_id);
    formData.append("payment_amount", payment.payment_amount);
    formData.append("payment_date", payment.payment_date);
    formData.append("payment_mode", payment.payment_mode);
    formData.append("transaction_ref", payment.transaction_ref);
    formData.append("notes", payment.notes);
    if (payment.payment_file) {
      formData.append("payment_file", payment.payment_file);
    }

    postClientDataResponse(
      clientHost + UPDATE_PAYMENT,
      storeFresh.key,
      formData,
      () => this.getPayments(),
      (err) => console.log(err)
    );
  };
 
  // ===== Export to Excel =====
  onExport = (filteredPayments) => {
    const data = filteredPayments.map((p, index) => ({
      "S.No": index + 1,
      "Vendor Name": this.state.vendors.find((v) => v.id === p.vendor_id)?.vendor_name || "",
      "Invoice Amount": this.state.invoices.find((inv) => inv.id === p.invoice_id)?.invoice_amount || "",
      "Payment Amount": p.payment_amount,
      "Status": this.state.invoices.find((inv) => inv.id === p.invoice_id)?.status || "",              // PAID, NOTPAID, PARTIAL, OVERPAID
       "Balance After":p.balance_after,
      //"Balance Amount": this.state.invoices.find((inv) => inv.id === p.invoice_id)?.balance_amount || "", 
      "Payment Date": p.payment_date,
      "Payment Mode": p.payment_mode,
      "Transaction Ref": p.transaction_ref,
      "Notes": p.notes,
      "Attachment URL": p.paymentFileUrl || "",
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);

    filteredPayments.forEach((p, idx) => {
      if (p.paymentFileUrl) {
        const row = idx + 2;
        const cell = `I${row}`;
        if (!worksheet[cell]) worksheet[cell] = {};
        worksheet[cell].l = { Target: p.paymentFileUrl };
      }
    });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Payments");

    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "Payments.xlsx");
  };

  render() {
    return (
      <VendorPaymentComponent
        payments={this.state.payments}
        vendors={this.state.vendors}
        invoices={this.state.invoices}
        // Form
        selectedVendor={this.state.selectedVendor}
        selectedInvoice={this.state.selectedInvoice}
        paymentAmount={this.state.paymentAmount}
        paymentDate={this.state.paymentDate}
        paymentMode={this.state.paymentMode}
        transactionRef={this.state.transactionRef}
        notes={this.state.notes}
        onVendorChange={this.onVendorChange}
        onInvoiceChange={this.onInvoiceChange}
        onPaymentAmountChange={this.onPaymentAmountChange}
        onPaymentDateChange={this.onPaymentDateChange}
        onPaymentModeChange={this.onPaymentModeChange}
        onTransactionRefChange={this.onTransactionRefChange}
        onNotesChange={this.onNotesChange}
        onPaymentFileChange={this.onPaymentFileChange}
        addPayment={this.addPayment}
        updatePayment={this.updatePayment}
        deletePayment={this.deletePayment}
        // Filters
        filterVendorId={this.state.filterVendorId}
        filterFromDate={this.state.filterFromDate}
        filterToDate={this.state.filterToDate}
        onFilterVendorChange={this.onFilterVendorChange}
        onFilterFromDateChange={this.onFilterFromDateChange}
        onFilterToDateChange={this.onFilterToDateChange}
        onResetFilters={this.onResetFilters}
        // Export
        onExport={this.onExport}
      />
    );
  }
}

export default VendorPaymentContainer;
